import React from "react";
import {
    Container,
    Row, 
    
} from "react-bootstrap";
import ReactGA from 'react-ga';
export default function Careers (){
    ReactGA.pageview(window.location.pathname + window.location.search);    
    return (

        <Container className='mt-5 mb-5'>
            <h1 className='text-center'>Change dentistry with us.</h1>
        <Row className='mt-5 mb-5 text-center' xs={1} md={1} lg={1} > 
            <h3>Interested in joining Opencare?</h3>
            <h5>We're a team of mission-driven, metrics obsessed individuals who are rapidly changing the slow-moving healthcare industry every single day. There are no limits, no politics, no hierarchy. But most importantly, we make sure everything we do is held to the highest quality standards because what we're building impacts the lives of real people.</h5>
        </Row>
        </Container>
    )
}


